import { Component, ElementRef, HostListener, Inject, OnDestroy, PLATFORM_ID } from '@angular/core';
import { isPlatformBrowser, DOCUMENT } from '@angular/common';
import { LoginServerService } from '../../../authentication/services/login-server.service';
import { UserService } from '../../../../pages/administrateur/service/user.service';
import { ChatMessage } from '../../../../pages/administrateur/gestion-jardin/gestion-messagarie/chat-message.model';
import { NotificationsService } from '../../../../pages/administrateur/service/notifications.service';
import { notificationsDTO } from '../../../../pages/administrateur/gestion-jardin/gestion-messagarie/models/notificationsDTO';
import { MessagerieService } from '../../../../pages/administrateur/service/messagerie.service';
import { Router } from '@angular/router';
import { EventService } from '../../../../pages/administrateur/service/event.service';
import { SuiviService } from '../../../../pages/administrateur/service/suivi.service';
import { SuiviResponseDTO } from '../../../../models/SuiviResponseDTO';
import { EtablissementService } from '../../../../pages/administrateur/service/etablissement.service';
import { environment } from '../../../../../environments/environement';
import { TranslateService } from '@ngx-translate/core';
import { ThemeService } from '../../../../core/services/theme.service';
import { ProfileUpdateService } from '../../../../pages/administrateur/service/profile-update.service';
declare var bootstrap: any
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnDestroy {
  private notifPollInterval: any = null;
  private unreadRefreshSub?: any;

  dropdownVisible = false;
  profileImageUrl: string = '../../../../assets/img/Admin.png'; // Default image path
  private userIdKey = parseInt(localStorage.getItem('userId') as string, 10);
  newMessageCount: number = 0;
  newNotificationCount: number = 0;
  currentUser: number | null = null;
  audio = new Audio('../../../../assets/audio/message.mp3 ');
  isAudioAllowed: boolean = false;
  notificationsVisible = false;
  notificationDropdownVisible = false;
  userNotifications: notificationsDTO[] = [];
  messages: ChatMessage[] = [];
  isPopupVisible: boolean = false;
  selectedEvent: any = null;
  selectedFullDate: string = '';
  suiviDetails: SuiviResponseDTO | null = null;
  commentaire: string = "";
  childImage?: string;
  content?: string;

  logoUrl: string = 'assets/img/monkey.png';
  nom: string = '';
  logoErrorDetails: string = '';
  private themeSubscription: any;

  isDirecteur(): boolean {
    return localStorage.getItem('_sid') === 'Directeur';
  }
  isParent(): boolean {
    return localStorage.getItem('_sid') === 'Parent';
  }
  isFormateur(): boolean {
    return localStorage.getItem('_sid') === 'Educateur';
  }

  getDefaultAvatar(): string {
    const role = localStorage.getItem('_sid');
    switch (role) {
      case 'Parent': return '../../../../assets/img/parent.png';
      case 'Educateur': return '../../../../assets/img/formateur1.png';
      case 'Directeur': return '../../../../assets/img/directeur.png';
      default: return '../../../../assets/img/Admin.png';
    }
  }


  suivis = [
    {
      title: 'Repas',
      options: [
        { icon: '🍽️', checked: false },
        { icon: '🍔', checked: false },
        { icon: '🥄', checked: false }
      ]
    },
    {
      title: 'Humeur',
      options: [
        { icon: '😐', checked: false },
        { icon: '🙂', checked: false },
        { icon: '😁', checked: false }
      ]
    },
    {
      title: 'Participation',
      options: [
        { icon: '🎁', checked: false },
        { icon: '🎲', checked: false },
        { icon: '🧩', checked: false }
      ]
    },
    {
      title: 'Sommeil',
      options: [
        { icon: '😴', checked: false },
        { icon: '😊', checked: false },
        { icon: '😪', checked: false }
      ]
    },
    {
      title: 'Interaction',
      options: [
        { icon: '👧', checked: false },
        { icon: '👦👧', checked: false },
        { icon: '👨‍👩‍👧‍👦', checked: false }
      ]
    },
    {
      title: 'jeuxExterieur',
      options: [
        { icon: '✅', checked: false },
        { icon: '❌', checked: false }
      ]
    }
  ];
  constructor(
    private notificationsService: NotificationsService,
    private messagerieService: MessagerieService,
    private authProvider: LoginServerService,
    private userService: UserService,
    private eventService: EventService,
    private suiviService: SuiviService,
    private router: Router,
    private eRef: ElementRef,
    private etablissementService: EtablissementService,
    public translate: TranslateService,
    private themeService: ThemeService,
    private profileUpdateService: ProfileUpdateService,
    @Inject(DOCUMENT) private document: Document,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    // Initialize translation
    translate.addLangs(['fr', 'en', 'ar']);
    translate.setDefaultLang('fr');
    const savedLang = localStorage.getItem('selectedLanguage');
    const browserLang = translate.getBrowserLang();
    translate.use(savedLang || (browserLang?.match(/fr|en|ar/) ? browserLang : 'fr'));

    // Just use saved/browser language, no RTL layout changes
  }

  switchLang(lang: string) {
    this.translate.use(lang);
    localStorage.setItem('selectedLanguage', lang);
  }

  private profileSub?: any;

  ngOnInit(): void {
    if (isPlatformBrowser(this.platformId)) {
      this.loadProfilePhoto();
      
      // Subscribe to profile updates for real-time photo changes
      this.profileSub = this.profileUpdateService.profileUpdated$.subscribe(event => {
        if (event.photo) {
          this.profileImageUrl = event.photo;
        }
      });
      
      // Subscribe to ThemeService for immediate logo/name updates
      this.themeSubscription = this.themeService.etablissement$.subscribe(etab => {
        if (etab) {
          this.logoErrorDetails = '';
          this.nom = etab.nom;
          if (!etab.logoUrl) {
            this.logoErrorDetails = '';
          }
          this.logoUrl = this.themeService.buildLogoUrl(etab.logoUrl);
        } else {
          // If null, we might need to load it (e.g., page refresh)
          const storedId = localStorage.getItem('etablissementId');
          if (storedId) {
            this.themeService.loadAndApplyTheme().subscribe();
          }
        }
      });
    }
    this.LoadNotifications();
    this.loadInitialMessageCount();

    // Refresh unread count when conversation is marked as read
    this.unreadRefreshSub = this.messagerieService.unreadCountRefreshed$.subscribe(() => {
      this.loadInitialMessageCount();
    });

    // Poll notifications every 5s for near-real-time updates
    if (isPlatformBrowser(this.platformId)) {
      this.notifPollInterval = setInterval(() => this.LoadNotifications(), 5000);
    }

    if (typeof document !== 'undefined') {
      document.body.addEventListener('click', this.enableAudio.bind(this), { once: true });
    }

    this.connectWebSocket();
    this.listenForMessages();
  }

  ngOnDestroy(): void {
    if (this.notifPollInterval) {
      clearInterval(this.notifPollInterval);
    }
    if (this.themeSubscription) {
      this.themeSubscription.unsubscribe();
    }
    if (this.unreadRefreshSub) {
      this.unreadRefreshSub.unsubscribe();
    }
    if (this.profileSub) {
      this.profileSub.unsubscribe();
    }
  }

  private loadInitialMessageCount(): void {
    this.messagerieService.getUnreadMessageCount(this.userIdKey).subscribe({
      next: (count) => { this.newMessageCount = count; },
      error: () => { /* silent */ }
    });
  }

  private connectWebSocket(): void {
    const currentUserId = localStorage.getItem('userId');
    this.currentUser = currentUserId ? +currentUserId : null;
    this.messagerieService.connect();
  }

  private listenForMessages(): void {
    this.messagerieService.messages$.subscribe({
      next: (message) => {
        if (!message) return;
        if (this.isMessageType1(message)) {
          this.messages.push(message);
          if (message.sender && message.sender !== this.currentUser && message.senderId !== this.currentUser) {
            this.newMessageCount += 1;
          }
        } else {
          this.LoadNotifications();
          if (message.sender && message.sender !== this.currentUser && message.senderId !== this.currentUser) {
            this.newNotificationCount += 1;
          }
        }
        this.playNotificationSound();
      },
      error: () => {},
    });
  }

  clearNotification(): void {
    this.newMessageCount = 0;
  }

  enableAudio(): void {
    this.isAudioAllowed = true;
  }

  playNotificationSound(): void {
    if (this.isAudioAllowed) {
      this.audio.play().catch(() => {});
    }
  }
  private loadProfilePhoto(): void {
    if (isPlatformBrowser(this.platformId)) {
      const savedImage = localStorage.getItem('profileImage');
      if (savedImage) {
        this.profileImageUrl = savedImage;
      } else {
        this.userService.getPhotoByUserId(this.userIdKey).subscribe({
          next: (photoUrl: string) => {
            this.profileImageUrl = photoUrl || this.getDefaultAvatar();
            localStorage.setItem('profileImage', this.profileImageUrl);
          },
          error: () => {
            this.profileImageUrl = this.getDefaultAvatar();
          },
        });
      }
    }
  }

  toggleDropdown(): void {
    this.dropdownVisible = !this.dropdownVisible;
    this.newNotificationCount = 0;
  }

  toggleMobileSidebar(): void {
    const offcanvasEl = document.getElementById('mobileSidebar');
    if (offcanvasEl) {
      const bsOffcanvas = new (window as any).bootstrap.Offcanvas(offcanvasEl);
      bsOffcanvas.toggle();
    }
  }

  navigateToMessages() {
    this.newMessageCount = 0;
    this.messages = [];
    this.messagerieService.clearMessages();
    this.router.navigate(['/beekids/messagaries']);
  }

  navigateToNotifications(type: string, notification: notificationsDTO) {
    this.markAsRead(notification);

    // ─── Événement ────────────────────────────────────────────────────────────
    if (type === 'EVENEMENT' && notification.evenementId) {
      this.fetchEventDetails(notification.evenementId);
      this.isPopupVisible = true;
      this.closeNotificationDropdown();
      this.router.navigate(['/beekids/event']);
      return;
    }

    // ─── Suivi ────────────────────────────────────────────────────────────────
    if (type === 'SUIVI') {
      this.childImage = notification.photoUrl;
      this.content = notification.content;
      this.loadSuiviDetails(notification.eleveId!, this.extractAndFormatDate(notification.content));
      this.openSuiviModal();
      this.closeNotificationDropdown();
      this.router.navigate(['/beekids/suivi']);
      return;
    }

    // ─── Menu ─────────────────────────────────────────────────────────────────
    if (type === 'MENU') {
      this.closeNotificationDropdown();
      this.router.navigate(['/beekids/cantine']);
      return;
    }

    // ─── Publication ──────────────────────────────────────────────────────────
    if (type === 'PUBLICATION') {
      this.closeNotificationDropdown();
      this.router.navigate(['/beekids/accueil']);
      return;
    }

    // ─── Demande Document ─────────────────────────────────────────────────────
    if (type?.startsWith('DEMANDE')) {
      this.closeNotificationDropdown();
      if (this.isFormateur()) {
        this.router.navigate(['/beekids/educateur-docs/demandes']);
      } else {
        this.router.navigate(['/beekids/accueil']);
      }
      return;
    }

    // ─── Congé ────────────────────────────────────────────────────────────────
    if (type?.startsWith('CONGE')) {
      this.closeNotificationDropdown();
      if (this.isFormateur()) {
        this.router.navigate(['/beekids/educateur-docs/conges']);
      } else {
        this.router.navigate(['/beekids/conges']);
      }
      return;
    }

    // ─── Contrat ──────────────────────────────────────────────────────────────
    if (type?.startsWith('CONTRAT')) {
      this.closeNotificationDropdown();
      this.router.navigate(['/beekids/gestion-contrats']);
      return;
    }

    // ─── Présence (enfant absent) ──────────────────────────────────────────────
    if (type === 'PRESENCE_ABSENT') {
      this.closeNotificationDropdown();
      this.router.navigate(['/beekids/presence']);
      return;
    }

    // ─── Cantine Alert → ouvrir conversation avec le parent ────────────────
    if (type === 'CANTINE_ALERT') {
      this.closeNotificationDropdown();
      const parentId = notification.userId;
      if (parentId) {
        this.router.navigate(['/beekids/messagaries'], {
          queryParams: { parentId }
        });
      } else {
        this.router.navigate(['/beekids/cantine']);
      }
      return;
    }

    // ─── Like / Comment ──────────────────────────────────────────────────────
    if (type === 'LIKE' || type === 'COMMENT') {
      this.closeNotificationDropdown();
      this.router.navigate(['/beekids/accueil']);
      return;
    }

    // ─── Paiement / Rappel ──────────────────────────────────────────────────
    if (type === 'PAIEMENT' || type === 'MESSAGE') {
      this.closeNotificationDropdown();
      if (this.isParent()) {
        this.router.navigate(['/beekids/profil'], { queryParams: { tab: 'paiement' } });
      } else {
        this.router.navigate(['/beekids/paie']);
      }
      return;
    }

    // ─── Fallback: accueil ──────────────────────────────────────────────────
    this.closeNotificationDropdown();
    this.router.navigate(['/beekids/accueil']);
  }

  /** Mark notification as read via HTTP */
  markAsRead(notification: notificationsDTO): void {
    if (!notification.read && notification.id) {
      this.notificationsService.markAsRead(notification.id).subscribe({
        next: () => {
          notification.read = true;
          this.newNotificationCount = Math.max(0, this.newNotificationCount - 1);
          // Reload from server so state persists on next refresh
          this.LoadNotifications();
        },
        error: () => { /* silent — navigation still proceeds */ }
      });
    }
  }

  /** Mark all notifications as read */
  markAllNotificationsAsRead(): void {
    if (this.newNotificationCount <= 0) return;
    this.notificationsService.markAllAsRead().subscribe({
      next: () => {
        this.userNotifications.forEach(n => n.read = true);
        this.newNotificationCount = 0;
        this.LoadNotifications();
      },
      error: () => {}
    });
  }

  /** Mark notification as unread */
  markAsUnread(event: MouseEvent, notification: notificationsDTO): void {
    event.stopPropagation();
    if (notification.read && notification.id) {
      this.notificationsService.markAsUnread(notification.id).subscribe({
        next: () => {
          notification.read = false;
          this.newNotificationCount++;
          this.LoadNotifications();
        },
        error: () => {}
      });
    }
  }

  /** Returns icon emoji for each notification type */
  getNotificationIcon(type: string): string {
    if (!type) return '🔔';
    if (type.startsWith('DEMANDE')) return '📄';
    if (type.startsWith('CONGE'))   return '🌴';
    if (type.startsWith('CONTRAT')) return '📋';
    if (type === 'PRESENCE_ABSENT') return '⚠️';
    if (type === 'EVENEMENT')       return '📅';
    if (type === 'SUIVI')           return '👶';
    if (type === 'MENU')            return '🍽️';
    if (type === 'PUBLICATION')     return '📢';
    if (type === 'LIVE')            return '🔴';
    if (type === 'LIKE')            return '👍';
    if (type === 'COMMENT')         return '💬';
    return '🔔';
  }

  /** Returns CSS class for notification badge color */
  getNotificationColor(type: string): string {
    if (!type) return 'notif-default';
    if (type === 'DEMANDE_REFUSED' || type === 'CONGE_REFUSED') return 'notif-danger';
    if (type === 'DEMANDE_ACCEPTED' || type === 'CONGE_ACCEPTED' || type === 'CONTRAT_CREATED') return 'notif-success';
    if (type === 'PRESENCE_ABSENT') return 'notif-warning';
    if (type === 'CONTRAT_EXPIRE')  return 'notif-danger';
    if (type.startsWith('DEMANDE') || type.startsWith('CONGE')) return 'notif-info';
    if (type === 'LIKE' || type === 'COMMENT') return 'notif-info';
    return 'notif-default';
  }


  private cleanupBackdrops(): void {
    if (typeof document !== 'undefined') {
      // Immediate cleanup
      document.body.classList.remove('modal-open');
      document.body.style.overflow = '';
      document.body.style.paddingRight = '';
      document.body.style.pointerEvents = '';

      // Remove all backdrops
      const backdrops = document.querySelectorAll('.modal-backdrop, .dropdown-backdrop, .offcanvas-backdrop');
      backdrops.forEach(backdrop => backdrop.remove());

      // Also close any open Bootstrap dropdowns
      const openDropdowns = document.querySelectorAll('.dropdown-menu.show');
      openDropdowns.forEach(dd => dd.classList.remove('show'));

      // Second pass after short delay to catch stragglers
      setTimeout(() => {
        document.body.classList.remove('modal-open');
        document.body.style.overflow = '';
        document.body.style.paddingRight = '';
        document.body.style.pointerEvents = '';
        const remaining = document.querySelectorAll('.modal-backdrop, .dropdown-backdrop, .offcanvas-backdrop');
        remaining.forEach(backdrop => backdrop.remove());
      }, 100);
    }
  }

  handleLogout(): void {
    this.authProvider.logout();
  }

  toggleNotificationDropdown() {
    this.notificationDropdownVisible = !this.notificationDropdownVisible;
    this.newNotificationCount = 0;
  }

  closeNotificationDropdown() {
    this.notificationDropdownVisible = false;
    this.newNotificationCount = 0;
    this.cleanupBackdrops();
  }

  LoadNotifications(): void {
    this.notificationsService.getUserNotifications().subscribe({
      next: (data) => {
        this.userNotifications = data;
        this.newNotificationCount = data.filter(n => !n.read).length;
      },
      error: () => {},
    });
  }
  private isMessageType1(message: any): boolean {
    return message.hasOwnProperty('id') &&
      message.hasOwnProperty('sender') &&
      message.hasOwnProperty('receiver');
  }

  closePopup() {
    this.isPopupVisible = false;
    this.selectedEvent = null;
    this.selectedFullDate = '';
  }

  fetchEventDetails(eventId: number): void {
    this.eventService.getEvenementById(eventId).subscribe({
      next: (event) => {
        this.selectedEvent = {
          ...event,
          userNom: event.userNom ?? 'Inconnu',
          userPrenom: event.userPrenom ?? '',
          userPhotoUrl: event.userPhotoUrl ?? ''
        };

        // 👉 Utilise la date de l'événement au lieu de la date de création
        if (event.dateEvent) {
          this.selectedFullDate = this.formatDateFr(event.dateEvent);
        } else {
          this.selectedFullDate = 'Date inconnue';
        }
      },
      error: () => {},
    });
  }
  formatDateFr(dateString: string): string {
    const date = new Date(dateString);

    const options: Intl.DateTimeFormatOptions = {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    };

    return date.toLocaleDateString('fr-FR', options);
  }

  // Charger les détails du suivi d'un élève pour aujourd'hui
  loadSuiviDetails(eleveId: number, day: string): void {
    this.clearCheckboxes();
    // Fetch suivi details from the service
    this.suiviService.getSuiviByDateAndEleveId(day, eleveId).subscribe(
      (data: SuiviResponseDTO) => {
        this.suiviDetails = data;
        this.commentaire = data.note || '';
        this.mapSuiviToCheckboxes(data);
      },
      (error) => {
        this.clearCheckboxes();
      }
    );
  }
  // Utility function to clear all checkboxes
  clearCheckboxes(): void {
    this.suivis.forEach(suiviCategory => {
      suiviCategory.options.forEach(option => {
        option.checked = false; // Reset all checkboxes to unchecked
      });
    });

    // Réinitialiser le commentaire
    this.commentaire = ''; // Assurez-vous de réinitialiser le commentaire
  }
  // Mapper les données reçues aux checkboxes
  mapSuiviToCheckboxes(suivi: SuiviResponseDTO): void {
    const mapping: Record<string, { icon: string; value: string }[]> = {
      Repas: [
        { icon: '🍽️', value: 'fort' },
        { icon: '🍔', value: 'moyen' },
        { icon: '🥄', value: 'faible' }
      ],
      Humeur: [
        { icon: '😁', value: 'fort' },
        { icon: '🙂', value: 'moyen' },
        { icon: '😐', value: 'faible' }
      ],
      Participation: [
        { icon: '🎁', value: 'fort' },
        { icon: '🎲', value: 'moyen' },
        { icon: '🧩', value: 'faible' }
      ],
      Sommeil: [
        { icon: '😊', value: 'fort' },
        { icon: '😪', value: 'moyen' },
        { icon: '😴', value: 'faible' }
      ],
      Interaction: [
        { icon: '👨‍👩‍👧‍👦', value: 'fort' },
        { icon: '👦👧', value: 'moyen' },
        { icon: '👧', value: 'faible' }
      ],
      jeuxExterieur: [
        { icon: '✅', value: 'oui' },
        { icon: '❌', value: 'non' }
      ]
    };

    // Iterate through the suivi categories
    this.suivis.forEach((suiviCategory) => {
      // Ensure keys match the expected data
      const suiviKey = suiviCategory.title; // La clé telle quelle
      let suiviValue = suivi[suiviKey as keyof SuiviResponseDTO];

      if (suiviValue === undefined) {
        // Si la clé telle quelle ne fonctionne pas, on essaie en minuscule
        const suiviKeyLower = suiviCategory.title.toLowerCase();
        suiviValue = suivi[suiviKeyLower as keyof SuiviResponseDTO];
      }

      // Maintenant, `suiviValue` contiendra la valeur correcte ou `undefined` si la clé n'existe pas.

      const categoryMapping = mapping[suiviCategory.title];

      if (suiviValue && categoryMapping) {
        suiviCategory.options.forEach((option) => {
          // Match the value to the icon based on mapping
          option.checked = categoryMapping.some(
            (map) => map.icon === option.icon && map.value === suiviValue
          );
        });
      }
    });
  }
  extractAndFormatDate(content: string): string | "" {
    const regex = /(\d{2})\/(\d{2})\/(\d{4})/;
    const match = content.match(regex);

    if (match) {
      const [_, day, month, year] = match;
      return `${year}-${month}-${day}`;
    }

    return "";
  }
  openSuiviModal(): void {
    const modalElement = document.getElementById('suiviModal2');
    if (modalElement) {
      const modal = new bootstrap.Modal(modalElement);
      modal.show();
    }
  }
  closeSuiviModal(): void {
    const modalElement = document.getElementById('suiviModal2');
    if (modalElement) {
      const modal = bootstrap.Modal.getInstance(modalElement);
      modal?.hide();
    }
  }

  // 👇 This will detect clicks outside the component
  @HostListener('document:click', ['$event'])
  closeDropdownOnOutsideClick(event: MouseEvent) {
    if (!this.eRef.nativeElement.contains(event.target)) {
      this.notificationDropdownVisible = false;
      this.dropdownVisible = false; // 👈 ajout pour fermer le menu profil
    }
  }

  loadEtablissementLogo(): void {
    // This is now handled entirely by ThemeService subscription in ngOnInit
  }

  handleImageError(event: any): void {
    this.logoErrorDetails = 'Erreur 404: Lien image invalide (' + event.target.src + ')';
    event.target.src = 'assets/img/monkey.png';
  }

}